export default __webpack_public_path__ + "static/media/hero-illustration-3.5d570171.svg";